import { RefObject } from 'react'
import { Settings } from 'react-slick'
import { userSubscribedLicence } from '../../services/endeavor'
import { SubCategory } from '../types/ContentStack'
import { Paging } from '../types/Endeavor'
import { LICENCE_STATUS } from './enum'
import {
    UPPERCASE_REGEX,
    LENGTH_REGEX,
    LOWERCASE_REGEX,
    NUMBER_REGEX,
    SPECIAL_CHARS_REGEX,
} from '../../utils/regex'

export const ALL_POSTS: SubCategory = {
    category: '',
    title: 'All',
}

export const CONTACT_REASON_DATA: Array<string> = [
    'Billing',
    'Cancellation',
    'Login/Password Issues',
    'Video Playback Issues',
    'Class Related Questions',
    'General Membership Questions',
    'iOS or Android App Issues',
    'TV App Issues (Roku, Fire TV, Apple TV)',
    'Change My Email Address',
    'Brand Partnerships, Collaborations & Press',
]

export const USER_ONBOARDING_STATUS = 'on-boarding-status'

export const TILE_CAROUSEL_SETTINGS: Settings = {
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 7.7,
    initialSlide: window.screen.width >= 768 ? -1 : 0,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                slidesToShow: 5.6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 6.6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3.6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                variableWidth: true,
            },
        },
    ],
}

export const HIGHLIGHTS_CAROUSEL_SETTINGS: Settings = {
    className: 'slider tile-slider',
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    variableWidth: true,
    responsive: [
        {
            breakpoint: 768,
            settings: 'unslick',
        },
    ],
}

export const INSTAGRAM_CAROUSEL_SETTINGS: Settings = {
    className: 'slider instagram-slider',
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
            },
        },
        {
            breakpoint: 768,
            settings: 'unslick',
        },
    ],
}

export const WORKOUT_CREATOR_CAROUSEL: Settings = {
    className: 'tile-slider workout-creator-slider',
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 7.7,
    initialSlide: window.screen.width >= 768 ? -1 : 0,
    responsive: [
        {
            breakpoint: 1100, // used to ipad landscape view
            settings: {
                slidesToShow: 5.7,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 6.6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 5.5,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 4.15,
                slidesToScroll: 1,
            },
        },
    ],
}

export const WORKOUT_CATEGORIES_CAROUSEL: Settings = {
    className: 'slider categories-slider',
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    rows: 2,
    dots: false,
    arrows: false,
    speed: 300,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 5,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2.3,
            },
        },
    ],
}

export const WORKOUT_VIDEO_CAROUSEL: Settings = {
    className: 'slider workout-video-slider',
    infinite: false,
    dots: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                arrows: false,
            },
        },
    ],
}

export const WEEKLY_SCHEDULE_CAROUSEL: Settings = {
    className: 'slider video-slider',
    infinite: false,
    slidesToShow: 7,
    slidesToScroll: 2,
    arrows: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 2,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3.5,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2.1,
                slidesToScroll: 1,
            },
        },
    ],
}

export const SECTION_ROW_CAROUSEL: Settings = {
    className: 'slider video-slider',
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 2,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 2,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2.5,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
            },
        },
    ],
}

export const MY_MWH_CAROUSEL: Settings = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2.1,
                slidesToScroll: 1,
            },
        },
    ],
}

export const PROGRAM_CATEGORIES_SETTINGS: Settings = {
    className: 'tile-slider program-categories-slider',
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 4.66,
    initialSlide: window.screen.width >= 768 ? -1 : 0,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4.6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                centerMode: false,
            },
        },
    ],
}

/**
 * Messages
 * Constant messages that will remain constant
 * throughout a the code base
 * These can be error, info, success messages
 */
export const MESSAGES = {
    error: {
        instagramFeed: "Sorry, this content isn't available right now.",
        invalidPasswordMsg: `Your password should be between 8-30 characters long and contain 1 capital letter, 1 lower case letter, 1 number, and 1 special character.`,
        invalidResetPasswordMsg: `Your password should be between 8-30 characters long and contain 1 capital letter, 1 lower case letter, 1 number, and 1 of the following special characters !@#$%^&*?-`,
        endpointError: 'Something went wrong. Please try again.',
        confirmPasswordMsg: 'Confirm password must match password',
        confirmPasswordRequired: 'Please enter confirm Password.',
        comparePassword: 'New password cannot match old password',
        compareGiftMail: 'Sender and Recipient Email can not be same',
        invalidOldPassword: 'Your old password is incorrect.',
        invalidLogin: 'You have entered an invalid username or password',
        termsAndCondition: 'You must accept terms to continue',
        invalidStripeError:
            'We are having trouble validating your credit card, Please try again.',
        invalidExpireDateOfCard:
            'This card has expired, please enter updated payment information.',
        paymentFailError:
            'The transaction failed due to technical error. Please try again.',
        userAlreadyExists:
            'User already exists, login to access your account, or please try with a different user email.',
        addBasketError: 'Your plan is not added to basket. Please try again.',
        newsletterError: (filed: string) =>
            `There's some error while ${filed}. Please try again.`,
        getUserDataError: (filed: string) =>
            `Can't get your ${filed}. Please try again.`,
        deleteUserData: (filed: string) =>
            `can't delete your save card. can you please try again.`,
        defaultUserData: (filed: string) =>
            `default ${filed} not set. Please try again.`,
        errorOnUpdate: (filed: string) =>
            `${filed} is not updated, Please try again`,
        licenceActionNotAllowed: (field: string) =>
            `${field} is not allowed for this licence.`,
        licenceActionFailed: (field: string) =>
            `${field} is not success, Please try again.`,
        required: (field: string, withValidText = true) =>
            `Please enter a ${withValidText ? 'valid' : ''} ${field}.`,
        select: (field: string) => `Please select ${field}.`,
        invalid: (field: string) => `Please enter a valid ${field}.`,
        invalidFileSize: (field: string, size: string) =>
            `${field} size greater than ${size}`,
        invalidFile: (fileType: string, field: string) =>
            `Please upload an ${fileType} file for ${field}`,
        invalidImageDimension: () => `Please upload 500x500 image dimension.`,
        emptyFilterResponse: () =>
            `No records found. Please select different filters`,
        invalidFilter: `Please select at least one filter`,
        noRecordFound: () => `No records found.`,
        redeemCodeAlreadyUsed: 'Redeem code already used',
        redeemGiftNotFound: 'Redeemable gift not found for code',
        incorredCode: 'Incorrect code, try again',
        enterPin: 'Please enter pin',
        invalidValue: (key: string) => `Invalid ${key}`,
        captchaVerificationFailed: 'Captcha verification failed',
        failedToGetVideos: 'Failed to get videos',
        licenceList: "Couldn't retrieve licence list. Please try again.",
        cantCompletePurchase:
            'We can�t complete your purchase at this time. Please return to billing information and use another payment method.',
        userDataMissing: 'User data is missing. Please try again.',
        logout: 'Failed to logout. Please try again.',
        playVideo: 'Failed to play video. Please try again.',
        scheduleLevel: 'Failed to get schedule and level.',
        searchBYTags: 'Failed to get products.',
        uploadFile: 'Failed to upload file.',
        updateUserImage: 'Failed to update user image.',
        getPage: (page: string) => `Failed to get ${page} page data`,
        getPostByUrl: 'Failed to get post.',
        getSubCategories: 'Failed to get categories',
        getFilters: 'Failed to get filters info.',
        failedTo: (operation: string, value = '') =>
            `Failed to ${operation} ${value}.`,
        somethingWentWrongWhile: (operation: string, value: string = '') =>
            `Something went wrong while ${operation} ${value}. Please try again.`,
        errorOnAdd: (field: string) =>
            `${field} is not added, Please try again`,
        list: (value: string) =>
            `Couldn't get ${value} list. Please try again.`,
        invalidQuery:
            'Something went wrong. Please try again with valid query.',
        invalidParamsQuery:
            'Please use numeric and alphabetical letters in search-box.',
        purchasedUserRedeemGift:
            'Gifts cannot be applied to active memberships. Please contact support@melissawoodhealth.com for assistance',
        invalidSpecialCharacters:
            'Sorry, but you cannot use special characters in your gift message.',
        // used to set empty error message.
        emptyMessage: 'empty',
        onlySpecificCharAllow:
            'Only following characters are allowed !@#$%^&*?-',
        minLengthError: (field: string, length: number) =>
            `${field} must be at least ${length} characters`,
        maxLengthError: (field: string, length: number) =>
            `${field} must be at most ${length} characters`,
    },
    info: {
        watchHistory: 'Please watch videos to generate class history',
        favorite: 'Please add videos to favorites.',
    },
    success: {
        giftPlanSuccessfullyPurchase:
            'Your gift purchase was successful. Confirmation has been sent to your email.',
        planSubscribedSuccessfully:
            'Your purchase was successful. Confirmation has been sent to your email. We are very excited to have you as a new member of our community.',
        passwordChanged: 'Password successfully changed. Please login again', //NOSONAR This is intentional
        requestSuccess: 'Your request has been success',
        noDefaultSavedCard:
            'Please add default card, in payment methods section.',
        noCardAddedForPayment:
            'You have no saved cards for payment, Please add card in payment method section.',
        planAction: 'Your plan action is under process. Please wait...',
        updateMessage: (filed: string) => `${filed} has been updated.`,
        licenceUpdate: (filed: string) => `Membership change successful`,
        licenceSuccess: (filed: string) =>
            `Your subscription has been ${filed}.`,
        giftRedeemSuccessfully: 'Gift was redeemed sucessfully',
        resetPasswordLinkSent: 'Password reset email sent.',
    },
}

export const stepsLabel = [
    {
        label: 'SELECT MEMBERSHIP',
    },
    {
        label: 'CREATE AN ACCOUNT',
    },
    {
        label: 'CHECKOUT',
    },
]

export const giftStepsLabel = [
    {
        label: 'RECIPIENT INFORMATION',
    },
    {
        label: 'MEMBERSHIP PLAN',
    },
    {
        label: 'BILLING INFORMATION',
    },
]

export const FILTERS_TYPE = ['Class Type', 'Body part', 'Category', 'Creator']

//This is the correct copy for Gift user licence. currently we are fetching this details from EDV
export const membershipPackage = [
    'Unlimited access to a library of 500+ workouts and meditations: Pilates + Yoga + Pre & Postnatal and more',
    'New classes every week + custom schedules for 3 tiers of intensity + live streamed classes',
    'Access to recipes & video tutorials + coveted lifestyle & nutrition tips',
]

export const giftMemberTermsAndConditions = [
    'At this time, gift cards can only be redeemed by new members.',
    'Gift cards can NOT be redeemed by existing members.',
    'Please be sure that the person you are purchasing a gift card for does not already have an MWH membership. If they already have a membership, they will not be able to redeem the gift card.',
    'Gifted memberships do not auto renew.',
]

export const giftLicenseDetails = [
    '7-day free trial for new members',
    '500+ workouts and meditations',
    'Custom programs',
    'New classes every week',
    'Custom schedules for 3 tiers of intensity',
    'Coveted lifestyle & nutrition tips, recipes and video tutorials',
]

export const membershipPackageGiftSubscription = {
    list: [
        'Unlimited access to a library of 500+ workouts and meditations: Pilates + Yoga + Pre & Postnatal and more',
        'New classes every week + custom schedules for 3 tiers of intensity + live streamed classes',
        'Access to recipes & video tutorials + coveted lifestyle & nutrition tips',
    ],
}

export const SHOP_RPP = 20
export const SHOP_SPLIT_LOOKS = 'SplitPost'
export const SHOP_MELISSA_LOOKS = "Melissa's looks"

export const VIDEO_RPP = 25
export const POST_RPP = 12

export const PAGING: Paging = {
    moreDataAvailable: false,
    lastSeen: 0,
}

export const SHOP_MWH_CODE = 'Discount codes'

export const SHOP_GIFT_GUIDE = 'Gift guide'

export const SHOP_MWH_PRODUCT = 'Mwh props'

export const SHOP_LIFE = 'Life'

export const SHOP_BEAUTY = 'Beauty'

export const SHOP_CATEGORIES = [
    SHOP_MWH_CODE,
    SHOP_GIFT_GUIDE,
    SHOP_MWH_PRODUCT,
    SHOP_LIFE,
    SHOP_BEAUTY,
]

export const MWH_MAIL_ID = 'members@melissawoodhealth.com'

export const SUPPORT_EMAIL = 'admin@melissawoodhealth.com'

export const PROD_DOMAIN = 'melissawoodhealth.com'

export const WEBVIEW = '?view=webview'

export const analyticsEvents = {
    USER_ACCOUNT_SIGNUP: 'user_account_signup',
    USER_LICENSE_PURCHASE: 'user_license_purchase',
    USER_LICENSE_CANCEL: 'user_license_cancel',
    USER_ACCOUNT_SIGNUP_FB: 'user_account_signup_facebook',
    USER_LICENSE_PURCHASE_FB: 'user_license_purchase_facebook',
    USER_LICENSE_CANCEL_FB: 'user_license_cancel_facebook',
    USER_APPLY_FILTERS: 'user_apply_filters',
    VIDEO_PLAY: 'video_play',
    USER_RECOMMENDED_PLAYLIST: 'user_recommended_playlist',
    USER_ACHIEVEMENTS: 'achievements_page_load',
    ONBOARDING_RESPONSES: 'onboarding_responses',
} as const

export const APP_LINKS = {
    playStore:
        'https://play.google.com/store/apps/details?id=com.melissawoodhealth&hl=en_US&gl=US',
    appStore: 'https://apps.apple.com/us/app/melissa-wood-health/id1488181674',
}

export const GET_IP_ADDRESS_URL = 'https://api.ipify.org?format=json'

export const IMAGES_DOMAIN = 'https://images.melissawoodhealth.com'

export const UTM_PARAM_SESSION_STORAGE_KEY = 'UTM_PARAMS'

export const FAQ_EXTERNAL_LINK = 'https://mwh.zendesk.com/hc/en-us'

export const WORKOUT_LEVELS = ['beginner', 'intermediate', 'challenging']

export const userLicence = async () => {
    const userPlan = await userSubscribedLicence()
    if (userPlan && userPlan?.length > 0) {
        if (userPlan[0]?.licences?.length > 0) {
            const activeLicence = userPlan[0]?.licences?.filter(
                (activePlan) =>
                    activePlan.status === LICENCE_STATUS.ACTIVE ||
                    activePlan?.licenceStatus.status ===
                        LICENCE_STATUS.TRIAL_ACTIVE
            )
            //Find min date of active licence
            const minDate = Math.min(
                ...activeLicence.map(
                    (item) => item.licenceStatus.expiryTimestamp
                )
            )
            const currentActiveLicence = userPlan[0]?.licences?.find(
                (activePlan) =>
                    activePlan.licenceStatus.expiryTimestamp === minDate
            )
            return { currentActiveLicence, activeLicence }
        }
    }
}

export const scrollToTop = (ref: RefObject<HTMLDivElement>) => {
    ref?.current && ref?.current !== null && ref.current.scrollTo(0, 0)
}

export const clearCacheAndReload = () => {
    if ('caches' in window) {
        // Clear all caches
        caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
                caches.delete(cacheName)
            })
        })
    }

    // Perform a hard refresh
    window.location.reload()
}

// a function to retry loading a chunk to avoid chunk load error for out of date code
export const lazyRetry = function <T>(
    componentImport: () => Promise<T>
): Promise<T> {
    return new Promise((resolve, reject) => {
        // check if the window has already been refreshed
        const hasRefreshed = JSON.parse(
            window.sessionStorage.getItem('retry-lazy-refreshed') ?? 'false'
        )

        // try to import the component
        componentImport()
            .then((component) => {
                window.sessionStorage.setItem('retry-lazy-refreshed', 'false') // success, so reset the refresh
                resolve(component)
            })
            .catch((error) => {
                if (!hasRefreshed) {
                    // not been refreshed yet
                    window.sessionStorage.setItem(
                        'retry-lazy-refreshed',
                        'true'
                    ) // we are now going to refresh
                    window.location.reload() // refresh the page
                } else {
                    reject(error) // Default error behavior as already tried refresh
                }
            })
    })
}

export const findCurrentTabInViewport = (rowRefs: any) => {
    const tabKeys = Object.keys(rowRefs.current)
    for (const tabKey of tabKeys) {
        const rect = rowRefs.current[tabKey]?.getBoundingClientRect()
        const windowHeight =
            window.innerHeight || document.documentElement.clientHeight
        const isInView = rect && rect.top >= 0 && rect.bottom <= windowHeight
        if (isInView) {
            return tabKey
        }
    }
    return ''
}

export const filterScrollOptions: ScrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'start',
    inline: 'start',
}

export const generateRandomNumber = () => {
    // Random number create with Crypto. By using Math.random getting security hotspot
    const crypto = window.crypto
    const array = new Uint32Array(1)

    return crypto.getRandomValues(array)[0]
}

export const DATA_DELETION_REQUEST_FORM_LINK =
    'https://docs.google.com/forms/d/e/1FAIpQLSc7ehiD77DzoUHd8Owdgqq1nBOjGmJsCweJYeqD3LtE7Q2I8w/viewform'

export const getRandomString = (length: number) => {
    const characters = 'abcdefghijklmnopqrstuvwxyzZ0123456789'
    const halfLength = Math.floor(length / 2)
    let randomString = ''

    for (let i = 0; i < length; i++) {
        if (i % halfLength === 0 && i !== 0) {
            randomString += '-'
        }

        const randomIndex = new Uint32Array(1)
        window.crypto.getRandomValues(randomIndex)
        const index = randomIndex[0] % characters.length

        randomString += characters.charAt(index)
    }

    return randomString
}

export const handleScroll = (
    scrollThreshold: number,
    callback: (scrollY: number) => void
) => {
    const scrollEventHandler = () => {
        const scrollY = window.scrollY
        if (scrollY >= scrollThreshold) {
            callback(scrollY)
        } else if (scrollY === 0) {
            setTimeout(() => {
                callback(0) // Add delay in the callback
            }, 100)
        }
    }

    window.addEventListener('scroll', scrollEventHandler)

    return () => {
        window.removeEventListener('scroll', scrollEventHandler)
    }
}

export const PASSWORD_RULES = [
    { label: '8-30 characters long', pattern: LENGTH_REGEX },
    { label: '1 capital letter', pattern: UPPERCASE_REGEX },
    { label: '1 lower case letter', pattern: LOWERCASE_REGEX },
    { label: '1 number', pattern: NUMBER_REGEX },
    { label: '1 special character !@#$%^&*?-', pattern: SPECIAL_CHARS_REGEX },
]
